import type { AccessoryDefinition } from "./AccessoryDefinition";
import type { ISunlabCaseDefinition } from "./ICaseDefinition/ISunlabCaseDefinition";
import type { SunlabsHandleDefinition } from "./SunlabsHandleDefiniton";
import type { SunlabsHingeDefinition } from "./SunlabsHingeDefinition";
import type { SunlabsSectionDefinition } from "./SunlabsSectionDefinition";
import type { WheelDefinition } from "./WheelDefinition";

export interface SunlabCaseDefinition extends ISunlabCaseDefinition {
  Accessories?: AccessoryDefinition[];
  CaseId: number;
  CornerBody: string | null;
  CornerCap: string;
  Count: number;
  CustomerId: number;
  CustomerName: string;
  Depth: number;
  EdgeProtectionBody: string;
  EdgeProtectionBodyConfiguration: string;
  EdgeProtectionBodyWidth: number;
  EdgeProtectionCap: string;
  EdgeProtectionCapConfiguration: string;
  EdgeProtectionCapWidth: number;
  Fastener: string;
  FastenerConfiguration: string;
  FoamBody: string;
  FoamBodyThickness?: number;
  FoamCap?: string;
  FoamCapThickness?: number;
  Handles: SunlabsHandleDefinition[];
  Height: number;
  HeightUnits?: number;
  Hinges: SunlabsHingeDefinition[];
  Keyboard?: string;
  KeyboardBrandAndModel?: string;
  LCornerCap?: string;
  LCornerBody?: string;
  OptionAccessoriesCompartment: boolean;
  OptionAdditionalBackRackRail: boolean;
  OptionLeatherHandle: boolean;
  OptionPlayableInCase: boolean;
  OptionRemovableCap: boolean;
  OptionStackable: boolean;
  OptionTrolleyFunction: boolean;
  OrderDate: string;
  Panel: string;
  PanelColor: string;
  PanelThickness: number;
  PriceSale: number;
  // biome-ignore lint/suspicious/noExplicitAny: legacy code
  PriceSaleCalculationData: any;
  Sections: SunlabsSectionDefinition[];
  SizeKeyCount?: number;
  Type: string;
  Wheels?: WheelDefinition[];
  Width: number;
  caseType?: string;
}

/** Customer field for CaseConf / Sunlabs imports; matches legacy `CaseConfApi.fetchOrderFromCaseConf`. */
export const LEGACY_THON_CUSTOMER_DISPLAY = "Thon- ";
